import type {
  ContractRecordMap,
  PlannableOverlapExtended
} from '@libs/data-access/entities'
import { usePlanningFormTranslation } from '@libs/utils/translations'
import { ShiftConflictResolution } from '@spa/scenes/Plannings/components/'
import { membershipsSelectors } from '@spa/scenes/Plannings/redux/selectors'
import { keyBy } from 'lodash-es'
import type { FC } from 'react'
import { useFormContext } from 'react-hook-form'

import type { RestFormData } from '../../../../hooks'

type Props = {
  contracts: ContractRecordMap
  plannableOverlapExtended: Pick<
    PlannableOverlapExtended,
    'contracts_only_shift_overlap'
  >
}

export const ShiftPlannedOverPeriod: FC<Props> = ({
  contracts,
  plannableOverlapExtended
}) => {
  const { tCommon } = usePlanningFormTranslation()
  const { control } = useFormContext<RestFormData>()
  const contractsOnlyShiftOverlap =
    plannableOverlapExtended.contracts_only_shift_overlap?.map(contract =>
      contract.user_contract_id.toString()
    ) || []
  const contractById = keyBy(contracts.toArray(), 'id')
  const memberships = membershipsSelectors.useGetCachedMap()

  const employeeNameList = contractsOnlyShiftOverlap.map(item => {
    const membershipId = contractById[item]?.membership_id
    const membership = memberships[membershipId]

    return tCommon('models.fullname', {
      value: {
        firstname: membership?.firstname,
        lastname: membership?.lastname
      }
    })
  })

  return (
    <ShiftConflictResolution
      employeeNameList={employeeNameList}
      control={control}
    />
  )
}
